import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from "react";
import PropTypes from "prop-types";
import deprecated from "prop-types-extra/lib/deprecated";
import MuiGrid from "@material-ui/core/Grid";
import classNames from "classnames";
export class Grid extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "render", () => {
      const {
        alignContent,
        alignItems,
        children,
        container,
        direction,
        id,
        item,
        justify,
        justifyContent,
        lg,
        md,
        sm,
        spacing,
        wrap,
        xl,
        xs,
        zeroMinWidth,
        className,
        ...otherProps
      } = this.props;
      return /*#__PURE__*/React.createElement(MuiGrid, _extends({
        alignContent: alignContent,
        alignItems: alignItems,
        container: container,
        direction: direction,
        id: id,
        className: classNames("prmbl-grid", className),
        item: item,
        justifyContent: justifyContent ? justifyContent : justify,
        lg: lg,
        md: md,
        sm: sm,
        spacing: spacing,
        wrap: wrap,
        xl: xl,
        xs: xs,
        zeroMinWidth: zeroMinWidth
      }, otherProps), children);
    });
  }
}
_defineProperty(Grid, "propTypes", {
  /**
   * Defines the align content style property. It's applied for all screen sizes.
   */
  alignContent: PropTypes.oneOf(["stretch", "center", "flex-start", "flex-end", "space-between", "space-around"]),
  /**
   * Defines the align items style property. It's applied for all screen sizes.
   */
  alignItems: PropTypes.oneOf(["flex-start", "center", "flex-end", "stretch", "baseline"]),
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * If `true`, the component will have the flex container behavior. You should be wrapping `items` with a container.
   */
  container: PropTypes.bool,
  /**
   * Defines the `flex-direction` style property. It is applied for all screen sizes.
   */
  direction: PropTypes.oneOf(["row", "row-reverse", "column", "column-reverse"]),
  /**
   * The html id
   */
  id: PropTypes.string,
  /**
   * If `true`, the component will have the flex `item` behavior. You should be wrapping `items` with a `container`.
   */
  item: PropTypes.bool,
  /**
   * @deprecated
   * Defines the `justify-content` style property. It is applied for all screen sizes. This prop is now deprecated. Use `justifyContent` instead.
   */
  justify: deprecated(PropTypes.oneOf(["flex-start", "center", "flex-end", "space-between", "space-around"]), "The prop `justify` is now deprecated. Use `justifyContent` instead."),
  /**
   * Defines the `justify-content` style property. It is applied for all screen sizes.
   */
  justifyContent: PropTypes.oneOf(["flex-start", "center", "flex-end", "space-between", "space-around"]),
  /**
   * Defines the number of grids the component is going to use. It's applied for the `lg` breakpoint and wider screens if not overridden.
   * Grid always has a size of 12, so using value 6 means the grid item will take up half the space. Allowing for another size 6 grid item to be alongside it.
   */
  lg: PropTypes.oneOf([false, "auto", true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * Defines the number of grids the component is going to use. It's applied for the `md` breakpoint and wider screens if not overridden.
   * Grid always has a size of 12, so using value 6 means the grid item will take up half the space. Allowing for another size 6 grid item to be alongside it.
   */
  md: PropTypes.oneOf([false, "auto", true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * Defines the number of grids the component is going to use. It's applied for the `sm` breakpoint and wider screens if not overridden.
   * Grid always has a size of 12, so using value 6 means the grid item will take up half the space. Allowing for another size 6 grid item to be alongside it.
   */
  sm: PropTypes.oneOf([false, "auto", true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * Defines the space between the type `item` component. It can only be used on a type `container` component.
   */
  spacing: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]),
  /**
   * Defines the `flex-wrap` style property. It's applied for all screen sizes.
   */
  wrap: PropTypes.oneOf(["nowrap", "wrap", "wrap-reverse"]),
  /**
   * Defines the number of grids the component is going to use. It's applied for the `xl` breakpoint and wider screens.
   * Grid always has a size of 12, so using value 6 means the grid item will take up half the space. Allowing for another size 6 grid item to be alongside it.
   */
  xl: PropTypes.oneOf([false, "auto", true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * Defines the number of grids the component is going to use. It's applied for all the screen sizes with the lowest priority.
   * Grid always has a size of 12, so using value 6 means the grid item will take up half the space. Allowing for another size 6 grid item to be alongside it.
   */
  xs: PropTypes.oneOf([false, "auto", true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * If `true`, it sets `min-width: 0` on the item.
   */
  zeroMinWidth: PropTypes.bool,
  /**
   * Classes to apply to the root
   */
  className: PropTypes.string,
  /**
   * HTML Role
   */
  role: PropTypes.string,
  /**
   * The component or element to render for the grid
   */
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
});
export default Grid;